export const locale = {
  loading: 'Loading...',
};
